import React from 'react'

import styles from '../styles/components/Drawer.module.scss'

export default (({ className, children }) => (
  <div className={`${styles.drawerBarTop} ${className ?? false}`}>
    {children}
  </div>
)) as React.FC<{ children?: React.ReactNode; className?: string }>
